var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelehealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 60,
    viewBox: "0 0 84 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 60,
    rx: 29.4545,
    fill: "#D8ECED"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10992_2751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.3228 41.2593H33.6145C32.1839 41.2593 31.0107 40.0861 31.0107 38.6555V14.6471C31.0107 13.2165 32.1839 12.0433 33.6145 12.0433H45.915C47.3456 12.0433 48.5188 13.2165 48.5188 14.6471V33.9508",
    stroke: "#148D9B",
    strokeWidth: 1.23703,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1162 12.0433L36.8225 14.1623H42.7124L43.4187 12.0433",
    stroke: "#148D9B",
    strokeWidth: 1.23703,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.582 38.7992H40.9523",
    stroke: "#148D9B",
    strokeWidth: 1.23703,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6183 18.6929H40.9168C41.2041 18.6929 41.4316 18.9263 41.4316 19.2076V20.8118H43.0357C43.317 20.8118 43.5505 21.0452 43.5505 21.3266V23.625C43.5505 23.9124 43.317 24.1398 43.0357 24.1398H41.4316V25.744C41.4316 26.0253 41.1981 26.2587 40.9168 26.2587H38.6183C38.337 26.2587 38.1035 26.0253 38.1035 25.744V24.1398H36.4994C36.2121 24.1398 35.9846 23.9064 35.9846 23.625V21.3266C35.9846 21.0452 36.2181 20.8118 36.4994 20.8118H38.1035V19.2076C38.1035 18.9203 38.337 18.6929 38.6183 18.6929Z",
    stroke: "#148D9B",
    strokeWidth: 1.23703,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4013 47.9569L54.0789 42.0012C53.4444 35.7163 51.2237 32.3463 48.5242 28.8268",
    stroke: "#148D9B",
    strokeWidth: 1.23703,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.25 43.3419C43.0772 39.948 44.6155 36.6379 43.0532 34.543L39.3661 31.5382C38.0672 29.9161 39.7911 27.7732 41.6227 28.6471L45.9742 30.9875C47.6682 32.035 48.991 33.8247 48.7576 35.8778",
    stroke: "#148D9B",
    strokeWidth: 1.23703,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.016 28.0365L29.0228 26.4204C28.2745 25.8099 28.1548 24.7025 28.7654 23.9543C29.3161 23.2719 30.2797 23.1163 31.016 23.5473",
    stroke: "#148D9B",
    strokeWidth: 1.23703,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0166 32.5559L28.2513 30.3113C27.5031 29.7008 27.3834 28.5934 27.9939 27.8452C28.5984 27.097 29.7118 26.9833 30.46 27.5878",
    stroke: "#148D9B",
    strokeWidth: 1.23703,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0166 36.123L28.1854 33.8246C27.5928 33.3457 27.4971 32.4658 27.9819 31.8732C28.4608 31.2807 29.3407 31.1909 29.9332 31.6697",
    stroke: "#148D9B",
    strokeWidth: 1.23703,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1975 47.957L41.156 46.1314L36.0203 41.259",
    stroke: "#148D9B",
    strokeWidth: 1.23703,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10992_2751"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.0001,
    height: 37.111,
    fill: "white",
    transform: "translate(27 11.4445)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelehealth);
export default __webpack_public_path__ + "static/media/Telehealth.5286c0ac63c56107aecadd8af8891986.svg";
export { ForwardRef as ReactComponent };